// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2430af39","455":"7a9f3170","977":"a6063a28"}[chunkId] + ".chunk.js";
};